import Link from "next/link";
import Image from "next/image";

const PLACEHOLDER_IMAGE =
  process.env.NEXT_PUBLIC_URL + "/images/icon_placeholder.png";

export default function Avatar({ isBusiness, ownerAvatar, businessSlug }) {
  const avatar = isBusiness
    ? ownerAvatar
      ? ownerAvatar
      : PLACEHOLDER_IMAGE
    : PLACEHOLDER_IMAGE;

  if (isBusiness) {
    return (
      <Link passHref href={`/negocios/${businessSlug}`}>
        <Image
          src={avatar}
          className="rounded-full"
          width={160}
          height={160}
          alt="imagen"
        />
      </Link>
    );
  }
  return (
    <Image
      src={avatar}
      // layout="responsive"
      className="rounded-full"
      width={160}
      height={160}
      alt="lel"
    />
  );
}
